export const VIEW_LAYOUT = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
};

export const PATH_DELIMITER = '.';
